<template>
  <div class="negative-container" :class="{'flex-align': center}">
    <img :src="svgSrc('ic_subtract')" alt="subtract">
    <div class="not-txt">{{ notTxt }}</div>
    <button class="button is-primary2" style="background-color: white" @click="$emit('clicked')">{{ button }}</button>
  </div>
</template>

<script>
  export default {
    name: 'BlockNegative',
    props: {
      notTxt: {
        type: String
      },
      button: {
        type: String
      },
      center: {
        type: Boolean,
        default: false
      }
    }
  }

</script>

<style lang="stylus" scoped>
  .negative-container
    background-color #FFF0EB
    color #ff5722
    font-size 13px
    line-height 18.82px
    padding 12px 16px
    display flex
    gap 0 12px
    img
      margin-top 2px
      height 16px
  .not-txt
    flex 1
    white-space pre-line
    padding-right 8px
</style>
